<template>
  <div class="pa-4">
    <v-card
      class="pa-6 mx-auto rounded-lg"
      elevation="0"
      max-width="1000"
      style="z-index: 100 !important"
    >
      <div id="page1">
        <div class="header">
          {{ $t('A instituição') }}
          <br />
          {{ institutionName }}
          <br />
          A/C: {{ toCareUser.name }}
        </div>

        <div class="pa-2">
          <br />
          <br />

          <p>
            {{ $t('ASSUNTO: Relatório de Desempenho') }}
          </p>

          <br />

          <p>
            {{
              $t(
                'Vimos por meio deste, formalizar a entrega do Relatório de Desempenho das atividades desempenhadas pelo setor durante o período na instituição'
              )
            }}
            {{ institutionName }}.
          </p>

          <br />

          <p>
            {{
              $t(
                'Para elaboração do mesmo, utilizamos os dados de apoio e indicadores gerados pelo software FixSystem - Software de gestão. Outros indicadores, listagens especificas ou maiores informações sobre o parque de equipamentos poderão ser solicitados pela administração se necessário.'
              )
            }}
          </p>

          <br />

          <p>
            {{
              $t(
                'A equipe permanece a inteira disposição e disponibiliza o contato dos responsáveis técnicos abaixo para o caso de qualquer dúvida'
              )
            }}:
          </p>

          <br />
          <br />

          <div class="d-flex justify-space-around">
            <div class="text-center">
              {{ executionUser.name }}
              <br />
              {{ offices[executionUser.userOffice] }}
              <br />
              {{ executionUser.cellPhoneNumber }}
            </div>

            <div class="text-center">
              {{ reviser.name }}
              <br />
              {{ reviser.userOffice }}
              <br />
              {{ reviser.cellPhoneNumber }}
            </div>
          </div>

          <br />
        </div>
      </div>

      <v-divider class="ma-4"></v-divider>

      <div id="page2">
        <div class="pa-2">
          <h2 class="primary--text my-4">{{ $t('Objetivos') }}:</h2>

          <p>
            {{
              'O presente relatório tem por objetivo apresentar os indicadores de desempenho, bem como as principais atividades realizadas pelo setor na instituição'
            }}
            {{ institutionName }}.
          </p>

          <br />

          <h2 class="primary--text my-4">
            {{ $t('Principais eventos do período') }}:
          </h2>

          <p class="text-start" style="white-space: pre-wrap">
            {{ lastEvents }}
          </p>

          <br />

          <h2 class="primary--text my-4">
            {{ $t('Eventos previstos para o próximo mês') }}:
          </h2>

          <p class="text-start" style="white-space: pre-wrap">
            {{ nextEvents }}
          </p>
        </div>
      </div>

      <v-divider class="ma-4"></v-divider>

      <div class="page3">
        <div class="pa-2">
          <h2 class="primary--text">{{ $t('Indicadores de Desempenho') }}:</h2>
          <br />

          <p>
            {{
              $t(
                'O sistema de gestão da qualidade para o presente serviço de Engenharia Clínica atualmente acompanha e supervisiona os seguintes indicadores de desempenho'
              )
            }}:
          </p>

          <br />

          <div
            class="d-flex align-center primary--text mt-4 mb-2"
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('1.'))
                .length > 0
            "
          >
            <h2 class="mr-2">1.0</h2>
            <span style="font-size: 18px">
              {{ $t('Indicadores quantitativos') }}
            </span>
          </div>

          <ul>
            <li
              v-for="select in chartInfos
                .map((x) => x.chart)
                .filter((x) => x.includes('1.'))
                .sort(
                  new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base',
                  }).compare
                )"
              :key="select"
            >
              <div class="d-flex align-center">
                <h3 class="mr-2">1.{{ chartsValues[select] }}</h3>
                <span> {{ select.split('-')[1] }} </span>
              </div>
            </li>
          </ul>

          <br
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('1.'))
                .length > 0
            "
          />

          <div
            class="d-flex align-center primary--text mt-4 mb-2"
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('2.'))
                .length > 0
            "
          >
            <h2 class="mr-2">2.0</h2>
            <span style="font-size: 18px">
              {{ $t('Indicadores de tempo médio') }}
            </span>
          </div>

          <ul>
            <li
              v-for="select in chartInfos
                .map((x) => x.chart)
                .filter((x) => x.includes('2.'))
                .sort(
                  new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base',
                  }).compare
                )"
              :key="select"
            >
              <div class="d-flex align-center">
                <h3 class="mr-2">2.{{ chartsValues[select] }}</h3>
                <span> {{ select.split('-')[1] }} </span>
              </div>
            </li>
          </ul>

          <br
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('2.'))
                .length > 0
            "
          />

          <div
            class="d-flex align-center primary--text mt-4 mb-2"
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('3.'))
                .length > 0
            "
          >
            <h2 class="mr-2">3.0</h2>
            <span style="font-size: 18px">
              {{ $t('Indicadores de custos de manutenção') }}
            </span>
          </div>

          <ul>
            <li
              v-for="select in chartInfos
                .map((x) => x.chart)
                .filter((x) => x.includes('3.'))
                .sort(
                  new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base',
                  }).compare
                )"
              :key="select"
            >
              <div class="d-flex align-center">
                <h3 class="mr-2">3.{{ chartsValues[select] }}</h3>
                <span> {{ select.split('-')[1] }} </span>
              </div>
            </li>
          </ul>

          <br
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('3.'))
                .length > 0
            "
          />

          <div
            class="d-flex align-center primary--text mt-4 mb-2"
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('4.'))
                .length > 0
            "
          >
            <h2 class="mr-2">4.0</h2>
            <span style="font-size: 18px">
              {{ $t('Indicadores de controle de qualidade') }}
            </span>
          </div>

          <ul>
            <li
              v-for="select in chartInfos
                .map((x) => x.chart)
                .filter((x) => x.includes('4.'))
                .sort(
                  new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base',
                  }).compare
                )"
              :key="select"
            >
              <div class="d-flex align-center">
                <h3 class="mr-2">4.{{ chartsValues[select] }}</h3>
                <span> {{ select.split('-')[1] }} </span>
              </div>
            </li>
          </ul>

          <br
            v-if="
              chartInfos.map((x) => x.chart).filter((x) => x.includes('4.'))
                .length > 0
            "
          />
        </div>
      </div>

      <v-divider class="ma-4"></v-divider>

      <div
        class="page4 my-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('1.'))
            .length > 0
        "
      >
        <div class="header">
          <div class="d-flex align-center ml-2" style="font-size: 16px">
            <h3 class="mr-2">1.0</h3>
            {{ $t('Indicadores quantitativos') }}
          </div>
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.1 - Equipamentos por setor')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.1 - Equipamentos por setor'] }}
            </h3>
            {{ $t('Equipamentos por setor') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2"
              >{{
                $t(
                  'Apresenta a quantidade de equipamentos em cada um dos setores da instituição até a data limite filtrada, desconsiderando alienados e acessórios.'
                )
              }}
            </span>
          </div>

          <EquipmentBySectorChart
            :filterProp="
              chartInfos.find((x) => x.chart == '1.1 - Equipamentos por setor')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '1.1 - Equipamentos por setor')
                .review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '1.1 - Equipamentos por setor')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.2 - Equipamentos Desativados no Período')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.2 - Equipamentos Desativados no Período'] }}
            </h3>
            {{ $t('Equipamentos Desativados no Período') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta a lista dos equipamentos alienados do sistema no período filtrado.'
                )
              }}
            </span>
          </div>
          <AlienatedEquip
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '1.2 - Equipamentos Desativados no Período'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '1.2 - Equipamentos Desativados no Período'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '1.2 - Equipamentos Desativados no Período'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.3 - Solicitações por setor')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.3 - Solicitações por setor'] }}
            </h3>
            Solicitações por setor
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o número de ordens de serviço de qualquer tipo solicitadas para cada setor do hospital no período filtrado.'
                )
              }}
            </span>
          </div>
          <RequestBySector
            :filterProp="
              chartInfos.find((x) => x.chart == '1.3 - Solicitações por setor')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '1.3 - Solicitações por setor')
                .review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '1.3 - Solicitações por setor')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.4 - Equipamentos Parados x Tipo de Pendencia')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{
                chartsValues['1.4 - Equipamentos Parados x Tipo de Pendencia']
              }}
            </h3>
            {{ $t('Equipamentos Parados x Tipo de Pendencia') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  "Apresenta a lista dos equipamentos com O.S. em aberto, nos quais o campo 'Máquina Parada' está preenchido sem data de retorno."
                )
              }}
            </span>
          </div>
          <StoppedEquipPendingType
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart == '1.4 - Equipamentos Parados x Tipo de Pendencia'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart == '1.4 - Equipamentos Parados x Tipo de Pendencia'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart == '1.4 - Equipamentos Parados x Tipo de Pendencia'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.5 - Top 5 equipamentos com mais falhas')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.5 - Top 5 equipamentos com mais falhas'] }}
            </h3>
            {{ $t('Top 5 equipamentos com mais falhas') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta os equipamentos com maior número de O.S.’s de manutenções corretivas fechadas, elencando as causas das falhas.'
                )
              }}
            </span>
          </div>
          <TopFiveEquipFailures
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '1.5 - Top 5 equipamentos com mais falhas'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '1.5 - Top 5 equipamentos com mais falhas'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '1.5 - Top 5 equipamentos com mais falhas'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.6 - Prevalência solução defeito')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.6 - Prevalência solução defeito'] }}
            </h3>
            {{ $t('Prevalência solução defeito') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o número de ordens de serviço concluídas no período para cada tipo de solução defeito.'
                )
              }}
            </span>
          </div>
          <DefectSolutionPrev
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '1.6 - Prevalência solução defeito'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '1.6 - Prevalência solução defeito'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '1.6 - Prevalência solução defeito'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.7 - Serviços solicitados x concluídos - Período')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{
                chartsValues[
                  '1.7 - Serviços solicitados x concluídos - Período'
                ]
              }}
            </h3>
            {{ $t('Serviços solicitados x concluídos - Período') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Indica quantas O.S.’s de cada tipo foram solicitadas e concluídas no período selecionado.'
                )
              }}
            </span>
          </div>
          <SolicitedVConcluded
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart == '1.7 - Serviços solicitados x concluídos - Período'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart == '1.7 - Serviços solicitados x concluídos - Período'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart == '1.7 - Serviços solicitados x concluídos - Período'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.8 - Corretivas solicitadas x executadas - Acumulado')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{
                chartsValues[
                  '1.8 - Corretivas solicitadas x executadas - Acumulado'
                ]
              }}
            </h3>
            {{ $t('Corretivas solicitadas x executadas - Acumulado') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o percentual das corretivas programadas que foram realizadas, incluindo as corretivas em aberto dos períodos anteriores.'
                )
              }}
            </span>
          </div>
          <CorrectiveScheXExec
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.8 - Corretivas solicitadas x executadas - Acumulado'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.8 - Corretivas solicitadas x executadas - Acumulado'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.8 - Corretivas solicitadas x executadas - Acumulado'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.9 - Resolutividade interna')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.9 - Resolutividade interna'] }}
            </h3>
            {{ $t('Resolutividade Interna') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  "Apresenta o número de O.S.'s corretivas fechadas pela equipe interna no período, dividido pelo total de corretivas fechadas no período, sempre em relação aos equipamentos próprios."
                )
              }}
            </span>
          </div>
          <InternalResolvability
            :filterProp="
              chartInfos.find((x) => x.chart == '1.9 - Resolutividade interna')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '1.9 - Resolutividade interna')
                .review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '1.9 - Resolutividade interna')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.10 - Preventiva x Corretiva')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.10 - Preventiva x Corretiva'] }}
            </h3>
            {{ $t('Preventiva x Corretiva') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta a quantidade de O.S.’s corretivas fechadas classificadas como Falha Intrínseca de equipamentos com criticidade maior ou igual a 12 e as compara com a quantidade de manutenções preventivas fechadas no mesmo período.'
                )
              }}
            </span>
          </div>
          <PreventiveXCorrective
            :filterProp="
              chartInfos.find((x) => x.chart == '1.10 - Preventiva x Corretiva')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '1.10 - Preventiva x Corretiva')
                .review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '1.10 - Preventiva x Corretiva')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.11 - Preventivas agendadas x executadas - Acumulado')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{
                chartsValues[
                  '1.11 - Preventivas agendadas x executadas - Acumulado'
                ]
              }}
            </h3>
            {{ $t('Preventivas Agendadas x Executas - Acumulado') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o percentual de execução das preventivas programadas no período filtrado, incluindo as preventivas em aberto dos períodos anteriores.'
                )
              }}
            </span>
          </div>
          <PreventiveSchedXExec
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.11 - Preventivas agendadas x executadas - Acumulado'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.11 - Preventivas agendadas x executadas - Acumulado'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.11 - Preventivas agendadas x executadas - Acumulado'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.12 - Calibrações agendadas x executadas')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.12 - Calibrações agendadas x executadas'] }}
            </h3>
            {{ $t('Calibrações agendadas x executadas - Acumulado') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o percentual de execução das calibrações programadas no período filtrado, incluindo as calibrações em aberto dos períodos anteriores.'
                )
              }}
            </span>
          </div>
          <CalibSchedXExec
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '1.12 - Calibrações agendadas x executadas'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '1.12 - Calibrações agendadas x executadas'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '1.12 - Calibrações agendadas x executadas'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes(
                '1.13 - Segurança elétrica agendada x executada - acumulado'
              )
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{
                chartsValues[
                  '1.13 - Segurança elétrica agendada x executada - acumulado'
                ]
              }}
            </h3>
            {{ $t('Segurança Elétrica agendada x executada - Acumulado') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o percentual de execução dos testes de segurança elétrica programados no período filtrado, incluindo os testes de segurança elétrica em aberto dos períodos anteriores.'
                )
              }}
            </span>
          </div>
          <EletricSecSchedXExec
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.13 - Segurança elétrica agendada x executada - acumulado'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.13 - Segurança elétrica agendada x executada - acumulado'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '1.13 - Segurança elétrica agendada x executada - acumulado'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('1.14 - Histórico de migração de equipamentos')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{
                chartsValues['1.14 - Histórico de migração de equipamentos']
              }}
            </h3>
            {{ $t('Histórico de migração de equipamentos') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Exibe a lista dos equipamentos que foram transferidos para outros setores ou unidades no período filtrado.'
                )
              }}
            </span>
          </div>
          <HistoricalMigration
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '1.14 - Histórico de migração de equipamentos'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '1.14 - Histórico de migração de equipamentos'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '1.14 - Histórico de migração de equipamentos'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            institution.departmentTypes.includes(1) &&
            chartInfos
              .map((x) => x.chart)
              .includes('1.15 - Solicitações por Oficina')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              1.{{ chartsValues['1.15 - Solicitações por Oficina'] }}
            </h3>
            {{ $t('Solicitações por Oficina') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o número de ordens de serviço solicitadas para cada oficina do hospital no período filtrado.'
                )
              }}
            </span>
          </div>
          <OrderByWorkshop
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '1.15 - Solicitações por Oficina'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '1.15 - Solicitações por Oficina'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '1.15 - Solicitações por Oficina'
              ).unidadeIds
            "
          />
        </div>
      </div>

      <v-divider
        class="ma-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('1.'))
            .length > 0
        "
      ></v-divider>

      <div
        class="page5 my-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('2.'))
            .length > 0
        "
      >
        <div class="header">
          <div class="d-flex align-center ml-2" style="font-size: 16px">
            <h3 class="mr-2">2.0</h3>
            {{ $t('Indicadores de tempo médio') }}
          </div>
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('2.1 - Tempo de máquina parada')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              2.{{ chartsValues['2.1 - Tempo de máquina parada'] }}
            </h3>
            {{ $t('Tempo de máquina parada') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o tempo de parada dos equipamentos filtrados no período.'
                )
              }}
            </span>
          </div>
          <StoppedMachine
            :institution="institution"
            :filterProp="
              chartInfos.find((x) => x.chart == '2.1 - Tempo de máquina parada')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '2.1 - Tempo de máquina parada')
                .review
            "
            :unidades="
              chartInfos.find((x) => x.chart == '2.1 - Tempo de máquina parada')
                .unidadeIds
            "
            :standardEquipments="standardEquipments"
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('2.2 - Tempo médio entre falhas por equipamento padrão')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              2.{{
                chartsValues[
                  '2.2 - Tempo médio entre falhas por equipamento padrão'
                ]
              }}
            </h3>
            {{ $t('Tempo médio entre falhas por equipamento padrão') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta a média de tempo entre as manutenções corretivas classificadas como falha intrínseca, organizadas por equipamento padrão no período selecionado.'
                )
              }}
            </span>
          </div>
          <StandEquipFailures
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '2.2 - Tempo médio entre falhas por equipamento padrão'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '2.2 - Tempo médio entre falhas por equipamento padrão'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart ==
                  '2.2 - Tempo médio entre falhas por equipamento padrão'
              ).unidadeIds
            "
            :standardEquipments="standardEquipments"
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('2.3 - Tempo médio entre falhas por equipamento')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              2.{{
                chartsValues['2.3 - Tempo médio entre falhas por equipamento']
              }}
            </h3>
            {{ $t('Tempo médio entre falhas por equipamento') }}
          </div>

          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta a média de tempo entre as manutenções corretivas classificadas como falha intrínseca, organizadas por ID dos equipamentos no período selecionado.'
                )
              }}
            </span>
          </div>
          <TotalServiceTime
            :filterProp="
              chartInfos.find(
                (x) =>
                  x.chart == '2.3 - Tempo médio entre falhas por equipamento'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) =>
                  x.chart == '2.3 - Tempo médio entre falhas por equipamento'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) =>
                  x.chart == '2.3 - Tempo médio entre falhas por equipamento'
              ).unidadeIds
            "
            :standardEquipments="standardEquipments"
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('2.4 - Atendimento x Previsão atendimento')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              2.{{ chartsValues['2.4 - Atendimento x Previsão atendimento'] }}
            </h3>
            {{ $t('Atendimento x Previsão atendimento') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta uma relação dos equipamentos e setores que não tiveram seus tempos de atendimento dentro das metas por criticidade estipuladas, de acordo com a data de solicitação da corretiva.'
                )
              }}
            </span>
          </div>
          <ServiceForecast
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '2.4 - Atendimento x Previsão atendimento'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '2.4 - Atendimento x Previsão atendimento'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '2.4 - Atendimento x Previsão atendimento'
              ).unidadeIds
            "
          />
        </div>
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.5 - Chamados atendidos no prazo')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.5 - Chamados atendidos no prazo'] }}
          </h3>
          {{ $t('Chamados Corretivos Atendidos no Prazo') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta uma relação dos chamados e seus tempos de atendimento, de acordo com a criticidade estipulada.'
              )
            }}
          </span>
        </div>
        <CallsAnsweredChart
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.5 - Chamados atendidos no prazo'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.5 - Chamados atendidos no prazo'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) => x.chart == '2.5 - Chamados atendidos no prazo'
            ).unidadeIds
          "
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.6 - Resolução x Previsão resolução')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.6 - Resolução x Previsão resolução'] }}
          </h3>
          {{ $t('Resolução x Previsão resolução') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta uma relação dos equipamentos e setores que não tiveram seus tempos de resolução dentro das metas por criticidade estipuladas, de acordo com a data de fechamento da corretiva.'
              )
            }}
          </span>
        </div>
        <ResolutionForecast
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.6 - Resolução x Previsão resolução'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.6 - Resolução x Previsão resolução'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) => x.chart == '2.6 - Resolução x Previsão resolução'
            ).unidadeIds
          "
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.7 - Chamados resolvidos no prazo')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.7 - Chamados resolvidos no prazo'] }}
          </h3>
          {{ $t('Chamados Corretivos Resolvidos no Prazo') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta uma relação dos chamados e seus tempos de resolução, de acordo com a criticidade estipulada.'
              )
            }}
          </span>
        </div>
        <CallsResolvedChart
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) => x.chart == '2.7 - Chamados resolvidos no prazo'
            ).unidadeIds
          "
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.8 - Tempo de atendimento interno por setor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.8 - Tempo de atendimento interno por setor'] }}
          </h3>
          {{ $t('Tempo de Atendimento Interno por Setor') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta uma média de tempo entre as solicitações e os atendimentos efetivos das O.S.’s de manutenção corretiva solicitadas no período filtrado, separadas por setor.'
              )
            }}
          </span>
        </div>
        <ServiceTimeDepartment
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.8 - Tempo de atendimento interno por setor'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.8 - Tempo de atendimento interno por setor'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) => x.chart == '2.8 - Tempo de atendimento interno por setor'
            ).unidadeIds
          "
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.9 - Tempo de atendimento interno por criticidade')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{
              chartsValues['2.9 - Tempo de atendimento interno por criticidade']
            }}
          </h3>
          {{ $t('Tempo de atendimento interno por criticidade') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta uma média de tempo entre as solicitações e os atendimentos efetivos das O.S.’s de manutenção corretiva solicitadas no período filtrado, separadas pela faixa de criticidade dos equipamentos.'
              )
            }}
          </span>
        </div>
        <ServiceTimeCrit
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart == '2.9 - Tempo de atendimento interno por criticidade'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart == '2.9 - Tempo de atendimento interno por criticidade'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) =>
                x.chart == '2.9 - Tempo de atendimento interno por criticidade'
            ).unidadeIds
          "
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="chartInfos.map((x) => x.chart).includes('2.10 - Tempo produtivo')"
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">2.{{ chartsValues['2.10 - Tempo produtivo'] }}</h3>
          {{ $t('Tempo Produtivo') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta o somatório do tempo total despendido em atendimento para cada colaborador da equipe técnica, registrado em tarefas e ordens de serviço do período filtrado.'
              )
            }}
          </span>
        </div>
        <ProdTime
          :filterProp="
            chartInfos.find((x) => x.chart == '2.10 - Tempo produtivo')
          "
          :isResult="true"
          :review="
            chartInfos.find((x) => x.chart == '2.10 - Tempo produtivo').review
          "
          :institution="institution"
          :unidades="
            chartInfos.find((x) => x.chart == '2.10 - Tempo produtivo')
              .unidadeIds
          "
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.11 - Tempo produtivo por setor')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{ chartsValues['2.11 - Tempo produtivo por setor'] }}
          </h3>
          {{ $t('Tempo produtivo por setor') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta o somatório do tempo total despendido em atendimento para cada setor, registrado em tarefas e ordens de serviço no período filtrado. O tempo total deve ser equivalente ao indicador acima.'
              )
            }}
          </span>
        </div>
        <ProdTimeSector
          :filterProp="
            chartInfos.find(
              (x) => x.chart == '2.11 - Tempo produtivo por setor'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) => x.chart == '2.11 - Tempo produtivo por setor'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) => x.chart == '2.11 - Tempo produtivo por setor'
            ).unidadeIds
          "
          :standardEquipments="standardEquipments"
        />
      </div>

      <div
        class="my-3"
        v-if="
          chartInfos
            .map((x) => x.chart)
            .includes('2.12 - Tempo médio de resolução interna por criticidade')
        "
      >
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <h3 class="mr-2">
            2.{{
              chartsValues[
                '2.12 - Tempo médio de resolução interna por criticidade'
              ]
            }}
          </h3>
          {{ $t('Tempo médio de resolução interna por criticidade') }}
        </div>
        <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
          <span class="mr-2">
            {{
              $t(
                'Apresenta uma média de tempo de resolução dos atendimentos corretivos de acordo com a criticidade dos equipamentos no período filtrado.'
              )
            }}
          </span>
        </div>
        <ResolutionTimeCrit
          :filterProp="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.12 - Tempo médio de resolução interna por criticidade'
            )
          "
          :isResult="true"
          :review="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.12 - Tempo médio de resolução interna por criticidade'
            ).review
          "
          :institution="institution"
          :unidades="
            chartInfos.find(
              (x) =>
                x.chart ==
                '2.12 - Tempo médio de resolução interna por criticidade'
            ).unidadeIds
          "
          :standardEquipments="standardEquipments"
        />
      </div>

      <v-divider
        class="ma-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('2.'))
            .length > 0
        "
      ></v-divider>

      <div
        class="page6 my-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('3.'))
            .length > 0
        "
      >
        <div class="header">
          <div class="d-flex align-center ml-2" style="font-size: 16px">
            <h3 class="mr-2">3.0</h3>
            {{ $t('Indicadores de custo de manutenção') }}
          </div>
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('3.1 - Custos por peça avulsa')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              3.{{ chartsValues['3.1 - Custos por peça avulsa'] }}
            </h3>
            {{ $t('Custos por Peça Avulsa') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{ $t('Apresenta os custos gerados por trocas de peças.') }}
            </span>
          </div>
          <CostPerPiece
            :filterProp="
              chartInfos.find((x) => x.chart == '3.1 - Custos por peça avulsa')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '3.1 - Custos por peça avulsa')
                .review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '3.1 - Custos por peça avulsa')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('3.2 - Custos por serviço avulso')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              3.{{ chartsValues['3.2 - Custos por serviço avulso'] }}
            </h3>
            {{ $t('Custos por serviço avulso') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta os custos gerados por serviços executados por terceiros, considerando a data de fechamento da O.S.'
                )
              }}
            </span>
          </div>
          <CostPerService
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '3.2 - Custos por serviço avulso'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '3.2 - Custos por serviço avulso'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '3.2 - Custos por serviço avulso'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos.map((x) => x.chart).includes('3.3 - Custo por setor')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">3.{{ chartsValues['3.3 - Custo por setor'] }}</h3>
            {{ $t('Custos por setor') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta os custos gerados por peças, serviços e contratos distribuídos por cada setor.'
                )
              }}
            </span>
          </div>
          <CostPerSector
            :filterProp="
              chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '3.3 - Custo por setor').review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '3.3 - Custo por setor')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('3.4 - Custo por ID equipamento')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              3.{{ chartsValues['3.4 - Custo por ID equipamento'] }}
            </h3>
            {{ $t('Custos por ID de equipamento') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{ $t('Apresenta o custo com serviço e peças por equipamento.') }}
            </span>
          </div>
          <CostPerId
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '3.4 - Custo por ID equipamento'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '3.4 - Custo por ID equipamento'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '3.4 - Custo por ID equipamento'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="chartInfos.map((x) => x.chart).includes('3.5 - Custo evitado')"
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">3.{{ chartsValues['3.5 - Custo evitado'] }}</h3>
            {{ $t('Custo evitado') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta o custo que seria acarretado à instituição caso não houvesse a intervenção da equipe de Engenharia Clínica presente no local.'
                )
              }}
            </span>
          </div>
          <AvoidedCosts
            :filterProp="
              chartInfos.find((x) => x.chart == '3.5 - Custo evitado')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '3.5 - Custo evitado').review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '3.5 - Custo evitado')
                .unidadeIds
            "
          />
        </div>
      </div>

      <v-divider
        class="ma-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('3.'))
            .length > 0
        "
      ></v-divider>

      <div
        class="page7 my-4"
        v-if="
          chartInfos.map((x) => x.chart).filter((x) => x.includes('4.'))
            .length > 0
        "
      >
        <div class="header">
          <div class="d-flex align-center ml-2" style="font-size: 16px">
            <h3 class="mr-2">4.0</h3>
            {{ $t('Indicadores de controle de qualidade') }}
          </div>
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('4.1 - Notas das avaliações O.S.')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              4.{{ chartsValues['4.1 - Notas das avaliações O.S.'] }}
            </h3>
            {{ $t('Notas das avaliações de Chamados') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta as avaliações das O.S.’s corretivas realizadas via módulo de chamados, definidas em: 1 – Ruim, 2 – Regular, 3 – Bom, 4 – Ótima.'
                )
              }}
            </span>
          </div>
          <OrderRatings
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '4.1 - Notas das avaliações O.S.'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '4.1 - Notas das avaliações O.S.'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '4.1 - Notas das avaliações O.S.'
              ).unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos.map((x) => x.chart).includes('4.2 - Ranking fornecedor')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              4.{{ chartsValues['4.2 - Ranking fornecedor'] }}
            </h3>
            {{ $t('Ranking fornecedor') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta a média das notas dadas ao tempo de atendimento e conclusão do serviço de fornecedores selecionados.'
                )
              }}
            </span>
          </div>
          <RankingSupplier
            :filterProp="
              chartInfos.find((x) => x.chart == '4.2 - Ranking fornecedor')
            "
            :isResult="true"
            :review="
              chartInfos.find((x) => x.chart == '4.2 - Ranking fornecedor')
                .review
            "
            :institution="institution"
            :unidades="
              chartInfos.find((x) => x.chart == '4.2 - Ranking fornecedor')
                .unidadeIds
            "
          />
        </div>

        <div
          class="my-3"
          v-if="
            chartInfos
              .map((x) => x.chart)
              .includes('4.3 - Adesão ao módulo de chamados')
          "
        >
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <h3 class="mr-2">
              4.{{ chartsValues['4.3 - Adesão ao módulo de chamados'] }}
            </h3>
            {{ $t('Adesão ao módulo de chamados') }}
          </div>
          <div class="d-flex align-center ml-2 mb-2" style="font-size: 16px">
            <span class="mr-2">
              {{
                $t(
                  'Apresenta a relação em porcentagem entre os chamados de manutenção corretiva feitos via módulo de chamados e o total de chamados de manutenção corretivas lançados no sistema.'
                )
              }}
            </span>
          </div>
          <AdhesionCalledMod
            :filterProp="
              chartInfos.find(
                (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
              )
            "
            :isResult="true"
            :review="
              chartInfos.find(
                (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
              ).review
            "
            :institution="institution"
            :unidades="
              chartInfos.find(
                (x) => x.chart == '4.3 - Adesão ao módulo de chamados'
              ).unidadeIds
            "
          />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import EquipmentBySectorChart from '../Reports/components/GenerateReport/components/charts/quantitative/equipmentBySector.vue'
import RequestBySector from '../Reports/components/GenerateReport/components/charts/quantitative/requestBySector.vue'
import TopFiveEquipFailures from '../Reports/components/GenerateReport/components/charts/quantitative/topFiveEquipFailures.vue'
import DefectSolutionPrev from '../Reports/components/GenerateReport/components/charts/quantitative/defectSolutionPrev.vue'
import SolicitedVConcluded from '../Reports/components/GenerateReport/components/charts/quantitative/solicitedVConcluded.vue'
import CorrectiveScheXExec from '../Reports/components/GenerateReport/components/charts/quantitative/correctiveSchedXExec.vue'
import InternalResolvability from '../Reports/components/GenerateReport/components/charts/quantitative/internalResolvability.vue'
import PreventiveXCorrective from '../Reports/components/GenerateReport/components/charts/quantitative/preventiveXCorrective.vue'
import PreventiveSchedXExec from '../Reports/components/GenerateReport/components/charts/quantitative/preventiveSchedxExec.vue'
import CalibSchedXExec from '../Reports/components/GenerateReport/components/charts/quantitative/calibSchedXExec.vue'
import EletricSecSchedXExec from '../Reports/components/GenerateReport/components/charts/quantitative/eletricSecSchedXExec.vue'
import AlienatedEquip from '../Reports/components/GenerateReport/components/charts/quantitative/alienatedEquip.vue'
import HistoricalMigration from '../Reports/components/GenerateReport/components/charts/quantitative/historicalMigration.vue'
import StoppedEquipPendingType from '../Reports/components/GenerateReport/components/charts/quantitative/stoppedEquipPendingType.vue'
import OrderByWorkshop from '../Reports/components/GenerateReport/components/charts/quantitative/orderByWorkshop.vue'

import StoppedMachine from '../Reports/components/GenerateReport/components/charts/time/stoppedMachine.vue'
import StandEquipFailures from '../Reports/components/GenerateReport/components/charts/time/standEquipFailures.vue'
import TotalServiceTime from '../Reports/components/GenerateReport/components/charts/time/totalServiceTime.vue'
import ServiceTimeDepartment from '../Reports/components/GenerateReport/components/charts/time/serviceTimeDepartment.vue'
import ServiceTimeCrit from '../Reports/components/GenerateReport/components/charts/time/serviceTimeCrit.vue'
import ProdTimeSector from '../Reports/components/GenerateReport/components/charts/time/prodTimeSector.vue'
import ProdTime from '../Reports/components/GenerateReport/components/charts/time/prodTime.vue'
import ResolutionTimeCrit from '../Reports/components/GenerateReport/components/charts/time/resolutionTimeCrit.vue'

import CostPerPiece from '../Reports/components/GenerateReport/components/charts/costs/costPerPiece.vue'
import CostPerService from '../Reports/components/GenerateReport/components/charts/costs/costPerService.vue'
import CostPerSector from '../Reports/components/GenerateReport/components/charts/costs/costPerSector.vue'
import CostPerId from '../Reports/components/GenerateReport/components/charts/costs/costPerId.vue'
import AvoidedCosts from '../Reports/components/GenerateReport/components/charts/costs/avoidedCosts.vue'

import OrderRatings from '../Reports/components/GenerateReport/components/charts/control/orderRatings.vue'
import RankingSupplier from '../Reports/components/GenerateReport/components/charts/control/rankingSupplier.vue'
import AdhesionCalledMod from '../Reports/components/GenerateReport/components/charts/control/adhesionCalledMod.vue'
import ServiceForecast from '../Reports/components/GenerateReport/components/charts/control/serviceForecast.vue'
import CallsAnsweredChart from '../Reports/components/GenerateReport/components/charts/control/CallsAnsweredChart.vue'
import ResolutionForecast from '../Reports/components/GenerateReport/components/charts/control/resolutionForecast.vue'
import CallsResolvedChart from '../Reports/components/GenerateReport/components/charts/control/CallsResolvedChart.vue'

export default {
  name: 'GeneratedReportService',

  components: {
    OrderByWorkshop,
    EquipmentBySectorChart,
    RequestBySector,
    TopFiveEquipFailures,
    DefectSolutionPrev,
    SolicitedVConcluded,
    CorrectiveScheXExec,
    InternalResolvability,
    PreventiveXCorrective,
    PreventiveSchedXExec,
    CalibSchedXExec,
    EletricSecSchedXExec,
    AlienatedEquip,
    HistoricalMigration,
    StoppedEquipPendingType,
    StoppedMachine,
    StandEquipFailures,
    TotalServiceTime,
    ServiceTimeDepartment,
    ServiceTimeCrit,
    ProdTimeSector,
    ProdTime,
    ResolutionTimeCrit,
    CostPerPiece,
    CostPerService,
    CostPerSector,
    CostPerId,
    AvoidedCosts,
    OrderRatings,
    RankingSupplier,
    AdhesionCalledMod,
    ServiceForecast,
    CallsAnsweredChart,
    ResolutionForecast,
    CallsResolvedChart,
  },

  data() {
    return {
      offices: [
        'Auxiliar',
        'Coordenador',
        'Enfermeiro',
        'Engenheiro',
        'Estagiário',
        'Recepcionista',
        'Supervisor',
        'Técnico',
        'Farmacêutico',
        'Fisioterapeuta',
        'Administrativo',
        'Gerente',
        'Nutricionista',
      ],
      apiService: new ApiService(),
      loading: false,
      institution: {},
      report: {},
      chartInfos: [],
      chartsValues: {},
      lastEvents: [],
      nextEvents: [],
      standardEquipments: [],
      toCareUser: '',
      reviser: '',
      executionUser: '',
      institutionName: '',
    }
  },

  async created() {
    await this.getReport()
  },

  methods: {
    async getStandardEquipments() {
      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )
    },

    async getReport() {
      this.loading = true
      await this.apiService
        .get(`generatedReport/link/${this.$route.params.link}`)
        .then((response) => {
          this.report = response.content
          const json = JSON.parse(this.report.content)

          this.institution = this.report.institution
          this.chartInfos = json.chartInfos
          this.lastEvents = json.lastEvents
          this.nextEvents = json.nextEvents
          this.toCareUser = json.toCareUser
          this.institutionName = json.institutionName
          this.reviser = json.reviser
          this.executionUser = json.executionUser

          this.chartInfos
            .map((x) => x.chart)
            .filter((x) => x.includes('1.'))
            .sort(
              new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: 'base',
              }).compare
            )
            .forEach((element, i) => {
              this.chartsValues[element] = i + 1
            })

          this.chartInfos
            .map((x) => x.chart)
            .filter((x) => x.includes('2.'))
            .sort(
              new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: 'base',
              }).compare
            )
            .forEach((element, i) => {
              this.chartsValues[element] = i + 1
            })

          this.chartInfos
            .map((x) => x.chart)
            .filter((x) => x.includes('3.'))
            .sort(
              new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: 'base',
              }).compare
            )
            .forEach((element, i) => {
              this.chartsValues[element] = i + 1
            })

          this.chartInfos
            .map((x) => x.chart)
            .filter((x) => x.includes('4.'))
            .sort(
              new Intl.Collator(undefined, {
                numeric: true,
                sensitivity: 'base',
              }).compare
            )
            .forEach((element, i) => {
              this.chartsValues[element] = i + 1
            })

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.header {
  padding: 10px;
  background: #0f3565;
  color: white;
  border-radius: 6px;
  border-top-right-radius: 37px;
}
</style>
